import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { Route, withRouter } from 'react-router-dom';
import { auth, messaging, db, storage } from './../../config/Fire';
import { connect } from 'react-redux';
import { setRestaurantById } from './../../actions/setRestaurantById';
import { setUserById } from './../../actions/setUserById';
import { getUser, getRestaurant, getError, getIsLoadingRestaurant, getErrorRestaurant } from './../../reducers';
import { setLogout } from './../../actions';
import MainMenuResto from '../../components/restaurant/MainMenuResto';
import { MenuResto, LOGIN } from '../../constants/menu_items';
import Home from './Home';
import TodayReservations from './TodayReservations';
import ReservationsHistorical from './ReservationsHistorical';
import ReservationsConfiguration from './ReservationsConfiguration';
import Analytical from './Analytical';
import Profile from './Profile';
import Comments from './Comments';
import ConfigurationBusinessDays from './ConfigurationBusinessDays';
import ConfigurationsGeneral from './ConfigurationsGeneral';
import LoadingPage from './../../components/LoadingPage';
import ErrorPageContainer from './../ErrorPage/ErrorPageContainer';
import * as Constants from './../../constants/nodes_database';
import PromotionsPerDay from './PromotionsPerDay';
import ReservationById from './ReservationById';
import ReservationsUsersAssisted from './ReservationsUsersAssisted';

const { Header, Content, Footer } = Layout;
const logo = require('./../../images/logo_reservando_word.png');

class MainResto extends Component {
    constructor(){
        super();
        this.state = {
            collapsed: false,
            itemSelected: MenuResto.HOME,
            isTokenLoaded: false,
            fileListProfile: [],
        };
    }

    onItemClick = ({itemClickType}) => {
        switch (itemClickType) {
            case MenuResto.HOME:
                this.props.history.push(`/${LOGIN}`);
                break;
            case MenuResto.LOGOUT:
                this.props.history.push(`/${LOGIN}`);
                this.props.setLogout();
                auth.signOut();
                break;
            default:
                this.props.history.push(`/${LOGIN}/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    componentDidMount() {
        const { user, restaurant, setRestaurantById } = this.props;
        if(!restaurant) {
            setRestaurantById(user.restaurantsId[0]);
        }
    }

    renderCloudMessaging() {
        if(!this.state.isTokenLoaded) {
            const { restaurant } = this.props;
            if(restaurant && restaurant.id) {
                messaging.requestPermission()
                .then(function() {
                    return messaging.getToken();
                    })
                    .then(function(token) {
                        db.ref(`${Constants.RESTAURANTS}/${restaurant.id}`).update({
                            firebaseTokenWeb: token
                        })
                        .then(() => {
                            
                        });
                    })
                    .catch(function(err) {
                        console.log("token not found: " + err);
                    })
                .catch(err => {
                    console.log("permission denied");
                });
            }
            this.setState({ isTokenLoaded: true });
        }
    }

    renderImageProfile() {
        if(this.state.fileListProfile.length === 0) {
            if(this.props.restaurant && this.props.restaurant.logo && this.props.restaurant.logo !== "") {
                var imagesProfile = [];
                storage.ref().child(this.props.restaurant.logo).getDownloadURL().then(url => {
                    imagesProfile.push({ uid: - 1, name: "0", status: 'done', url: url });
                    this.setState({ fileListProfile: imagesProfile });
                });
            }
        }
    }
    
    render() {
        const { restaurant, location, isLoadingRestaurant, errorRestaurant } = this.props;
        return (
            <div className="MainRestoCont">
                {
                    errorRestaurant.state ?
                        <ErrorPageContainer />
                        :
                        isLoadingRestaurant ?
                            <LoadingPage />
                            :
                            restaurant &&
                                <Layout style={{ minHeight: '100vh' }}>
                                    {/*<Menu className="HeaderMenuCont" theme="dark" mode="inline" selectable={false} style={{ lineHeight: '64px' }}>
                                        <Menu.Item key="0" style={{ textAlign:"center"}} title={ (restaurant && restaurant.name) && restaurant.name }>
                                            <span><h2><Avatar size={32} src={this.state.fileListProfile.length > 0 ? this.state.fileListProfile[0].url : imageReservando} /> { (restaurant && restaurant.name) && restaurant.name }</h2></span>
                                        </Menu.Item>
                                    </Menu>*/}
                                    <MainMenuResto onItemClick={this.onItemClick} itemSelected={location.pathname} fileListProfile={this.state.fileListProfile} name={(restaurant && restaurant.name) && restaurant.name} />
                                    <Layout>
                                        <Header style={{ background: '#fff', padding: 0 }} >
                                            <img alt="example" src={logo} style={{ display:"block", margin:"auto", maxHeight:"100%" }} />
                                        </Header>
                                        <Content style={{ margin: '8px 8px' }}>
                                                <div style={{ background: '#fff' }}>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.RESERVATIONS_HISTORICAL}`} component={ ReservationsHistorical }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.RESERVATIONS_CONFIGURATION}`} component={ ReservationsConfiguration }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.RESERVATIONS_USERS_ASSISTED}`} component={ ReservationsUsersAssisted }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.ANALYTICAL}`} component={ Analytical }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.PROFILE}`} component={ Profile }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.COMMENTS}`} component={ Comments }/>
                                                    {/*<Route exact path={`/${LOGIN}/${MenuResto.PROMOTIONS}`} component={ Promotions }/>*/}
                                                    <Route exact path={`/${LOGIN}/${MenuResto.PROMOTIONS_PER_DAY}`} component={ PromotionsPerDay }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.CONFIGURATION_BUSINESS_DAYS}`} component={ ConfigurationBusinessDays }/>
                                                    <Route exact path={`/${LOGIN}/${MenuResto.CONFIGURATIONS_GENERAL}`} component={ ConfigurationsGeneral }/>
                                                    <Route exact path={`/${LOGIN}`} component={ TodayReservations }/>
                                                    <Route path={`/${LOGIN}/${MenuResto.RESERVATION_BY_ID}`} component={ ReservationById }/>
                                                    {/* {<Route exact path={`/${LOGIN}`} component={ Home } />} */}
                                                </div>
                                        </Content>
                                        <Footer style={{ textAlign: 'center' }}>
                                            Copyright ©2019 Reservando
                                        </Footer>
                                    </Layout>
                                    {
                                        this.renderCloudMessaging()
                                    }
                                    {
                                        this.renderImageProfile()
                                    }
                                </Layout>
                }
                
            </div>
        );
    };
}

MainResto.propTypes = {
    setRestaurantById: PropTypes.func.isRequired,
    setUserById: PropTypes.func.isRequired,
    setLogout: PropTypes.func.isRequired,
    user: PropTypes.object,
    restaurant: PropTypes.object,
    isLoadingRestaurant: PropTypes.bool.isRequired,
    errorRestaurant: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setRestaurantById: value => dispatch(setRestaurantById(value)),
    setUserById: value => dispatch(setUserById(value)),
    setLogout: value => dispatch(setLogout(value)),
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
    restaurant:  getRestaurant(state),
    error: getError(state),
    isLoadingRestaurant: getIsLoadingRestaurant(state),
    errorRestaurant: getErrorRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(MainResto));